export const THREAT_INTEL_CUST_AVAILABLE_OPTIONS = [
  'MSP Center',
  'Threat Intelligence',
  'Advanced Settings',
  'Threat Intelligence Feed',
  'Settings',
  'Logout',
]

export const THREAT_INTEL_CUST_LICENSE_CODE = 'TISOC'
export const PHISH_PROT_SUITE_CUST_LICENSE_CODE = 'PHISHPROTSUITE'
export const BASIC_PROT_CUST_LICENSE_CODE = 'BASICPHISH'



export const THREAT_INTEL_CUST_VALID_PATHS = [
  '/tenant-admin', //MSP Center
  '/threat-intel',
  '/customers/:id/settings',
  '/customers/:id/settings/add-admin',
  '/advanced-settings',
  '/threat-intel-feed/:id',
]

export const THREAT_INTEL_CUST_SETTINGS_VALID_TABS = [
  'Profile',
  'Account',
  'Admin Management'
]

export const THREAT_INTEL_DISABLED_MESSAGE = 'This feature is not available for customers with Exclusive Threat Intelligence Access.'
export const BASIC_PROT_DISABLED_MESSAGE = 'This feature is not available for customers without Threat Intelligence Access.'